import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CourseCertificate from './CourseCertificate';

interface CertificateDialogProps {
  open: boolean;
  onClose: () => void;
  studentName: string;
  courseName: string;
  completionDate: string;
  position?: string;
  companyName?: string;
  companyLogo?: string;
  certificateSigner?: {
    firstName?: string;
    lastName?: string;
    position?: string;
    signature?: string;
  };
  showCTOSignature?: boolean;
  hideShareButtons?: boolean;
  allowViewCertificates?: boolean;
  /** Título del diálogo (p. ej. vista previa desde edición de empresa) */
  dialogTitle?: string;
}

const CertificateDialog: React.FC<CertificateDialogProps> = ({
  open,
  onClose,
  studentName,
  courseName,
  completionDate,
  position = "Completado",
  companyName,
  companyLogo,
  certificateSigner,
  showCTOSignature = true,
  hideShareButtons = false,
  allowViewCertificates = true,
  dialogTitle = '¡Felicitaciones! Has completado el curso'
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#f5f5f5',
          padding: 2
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        paddingBottom: 1
      }}>
        <Typography variant="h6" component="div">
          {dialogTitle}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: 'grey.500' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ padding: 0, display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ padding: 2 }}>
          <CourseCertificate
            studentName={studentName}
            courseName={courseName}
            completionDate={formatDate(completionDate)}
            position={position}
            companyName={companyName}
            companyLogo={companyLogo}
            certificateSigner={certificateSigner}
            showCTOSignature={showCTOSignature}
            onDownload={onClose}
            hideShareButtons={hideShareButtons}
            allowViewCertificates={allowViewCertificates}
          />
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CertificateDialog;
